(function () {
  'use strict';

  function getYouTubeId(url) {
    if (!url) return '';

    var match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?#\s]+)/
    );

    return match ? match[1] : '';
  }

  function getVimeoId(url) {
    if (!url) return '';

    var match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : '';
  }

  function getEmbedUrl(url) {
    if (!url) return '';

    var youtubeId = getYouTubeId(url);

    if (youtubeId) {
      return (
        'https://www.youtube.com/embed/' +
        youtubeId +
        '?autoplay=1&rel=0'
      );
    }

    var vimeoId = getVimeoId(url);

    if (vimeoId) {
      return (
        'https://player.vimeo.com/video/' +
        vimeoId +
        '?autoplay=1'
      );
    }

    return url;
  }

  function initHero(section) {
    if (!section) return;

    if (section.dataset.larppacksInitialized === 'true') {
      return;
    }

    section.dataset.larppacksInitialized = 'true';

    var modal = section.querySelector('.js-modal');
    var modalClose = section.querySelector('.js-modal-close');
    var videoButton = section.querySelector('.js-video-play');
    var iframe = section.querySelector('.lp-hero__modal-video');
    var gridItems = section.querySelectorAll('.js-play-clip');

    function openModal(videoUrl) {
      if (!modal || !iframe || !videoUrl) return;

      var embedUrl = getEmbedUrl(videoUrl);

      if (!embedUrl) return;

      iframe.src = embedUrl;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      if (iframe) {
        iframe.src = '';
      }
    }

    if (videoButton) {
      videoButton.addEventListener('click', function (event) {
        event.preventDefault();

        var videoUrl = videoButton.getAttribute('data-video');
        openModal(videoUrl);
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        modal &&
        modal.classList.contains('is-active')
      ) {
        closeModal();
      }
    });

    gridItems.forEach(function (item) {
      item.addEventListener('click', function (event) {
        event.preventDefault();

        var videoUrl = item.getAttribute('data-video');

        if (videoUrl) {
          openModal(videoUrl);
        }
      });
    });
  }

  function initAllHeroes(root) {
    var container = root || document;
    var sections = container.querySelectorAll(
      '[data-section-type="larppacks-hero"]'
    );

    sections.forEach(function (section) {
      initHero(section);
    });
  }

  function start() {
    initAllHeroes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (
      section &&
      section.matches('[data-section-type="larppacks-hero"]')
    ) {
      initHero(section);
      return;
    }

    initAllHeroes(section);
  });
})();